import axios from "axios";

//axios.defaults.baseURL = import.meta.env.VITE_API_URL;
//axios.defaults.baseURL = "http://172.20.10.4:3000";
axios.defaults.baseURL = "http://46.101.194.80:3000";
//axios.defaults.baseURL = "http://46.101.194.80:3000";
//axios.defaults.baseURL = "http://64.23.186.36:3000";
//axios.defaults.withCredentials = true;